module.exports = __webpack_public_path__ + "img/quility-create-account.2ada67c7.png";